import { connect } from 'react-redux';
import { exitDuperbrowse } from '../../../Duperbrowse/redux/actionCreators';
import { getCurrentItem } from '../../../Duperbrowse/redux/selectors';
var mapStateToProps = function (state) { return ({
    currentDuperbrowseItem: getCurrentItem(state),
}); };
var mapDispatchToProps = {
    exitDuperbrowse: exitDuperbrowse,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=BackButton.container.js.map